export const SseEventsEnum = {
  PLAYER_BONUS_CHANGED: 'bonuses_changes',
  PLAYER_BALANCE_UPDATED: 'balance',
  PLAYER_DEPOSIT_REQUIRED: 'deposit_required',
} as const;
